/* Jednorázové upozornění „Co vidí tvůj manažer" — zvoneček (NotificationCenter).
 *
 * PROČ (majitel 12. 10. 2026: „Jednou jim to oznámit ve zvonečku")
 * -----------------------------------------------------------------
 * Výkon týmu ukazuje manažerovi i patrům nad ním, kolik hovorů a schůzek
 * u klientů má poradce týdně a kdy byl s klientem naposledy v kontaktu.
 * Kdo přijímá pozvánku teď, tu větu vidí na kartě pozvánky (a server si
 * zapíše `informace_verze`). Kdo je v týmu ODDŘÍV, ji nikdy neviděl. Proto
 * mu ji zvoneček JEDNOU ukáže a po zobrazení se na vztah zapíše verze věty
 * (POST /api/manager/my-relationship/informace). Podruhé už nikdy — server
 * zápis podmiňuje tím, že verze ještě zapsaná není, a GET my-relationship
 * pak vrací `informace.potvrzena = true`.
 *
 * KDY SE UKÁŽE
 * ------------
 * Jen když server výslovně řekne „potvrzený vztah, věta nezapsaná" A verze
 * věty na serveru je ta, kterou tenhle frontend zná. Starší server (bez pole
 * `informace`) nebo jiná verze = NEVÍME → neukazovat; zápis by stejně neprošel
 * a ukazovat větu, o jejímž zobrazení nevznikne záznam, nemá smysl.
 */
import { INFORMACE_VERZE } from "@/components/manazer/pozvankyTexty";

/** Má zvoneček ukázat jednorázovou větu o tom, co vidí manažer? */
export function informaceKZobrazeni(rel) {
  if (!rel || typeof rel !== "object") return false;
  const m = rel.manager;
  if (!m || typeof m !== "object") return false;
  const inf = rel.informace;
  if (!inf || typeof inf !== "object") return false;
  return inf.potvrzena === false && inf.verze === INFORMACE_VERZE;
}

/** Má smysl zápis zkusit znovu? 404 (vztah už není) a 409 (jiná verze věty)
 *  se opakováním nespraví — upozornění se pak schová. Síť / 5xx ano. */
export function zapisMaSmyslOpakovat(chyba) {
  const kod = chyba && chyba.response ? chyba.response.status : null;
  return !(kod === 404 || kod === 409 || kod === 422 || kod === 401 || kod === 403);
}

export { INFORMACE_VERZE };
export default informaceKZobrazeni;
